






















































import { Component, Vue } from "vue-property-decorator";
import { ServerResult } from "@/core/http/server_result";

const LIST_OP = "PRODUCT_TYPES";

@Component
export default class ProductTypeForecastGroupForm extends Vue {
  loading = true;
  saving = false;
  rows: any[] = [];

  created() {
    this.load();
  }

  load() {
    this.loading = true;
    (this as any).$db([
      (this as any).$q(LIST_OP)
        .raw("documents.list")
        .action({
          columns: {
            id: "pt.id",
            name: "pt.name",
            forecast_group: "pt.forecast_group",
            record_type: "pt.record_type",
            parent_id: "pt.parent_id"
          },
          from: "s:products_types",
          from_as: "pt",
          where: {
            $and: [
              { $eq: ["pt.record_type", { $: "type" }] },
              { $null: ["pt.parent_id"] }
            ]
          },
          order_by: [
            { field: "pt.position", direction: "asc" },
            { field: "pt.name", direction: "asc" }
          ],
          page_size: 500,
          page: 1
        }),
      (this as any).$q("PRODUCT_PARENTS")
        .raw("documents.list")
        .action({
          columns: {
            id: "pt.id",
            parent_id: "pt.parent_id"
          },
          from: "s:products_types",
          from_as: "pt",
          where: {
            $eq: ["pt.record_type", { $: "parent_product" }]
          },
          page_size: 5000,
          page: 1
        })
    ])
      .then((result: ServerResult) => {
        const content = result.getOperation(LIST_OP).getContent();
        const parentsContent = result.getOperation("PRODUCT_PARENTS").getContent();

        const parentsByTypeId: Record<string, any[]> = {};
        (parentsContent.documents || []).forEach((doc: any) => {
          const parentId = doc.id?.pk || doc.id;
          const typeId = doc.parent_id?.pk || doc.parent_id;
          if (typeId == null) {
            return;
          }
          const key = String(typeId);
          if (!parentsByTypeId[key]) {
            parentsByTypeId[key] = [];
          }
          parentsByTypeId[key].push(parentId);
        });

        this.rows = (content.documents || [])
          .filter((doc: any) => {
            const recordType = doc.record_type || "type";
            const parentId = doc.parent_id?.pk || doc.parent_id;
            return recordType === "type" && (parentId == null || parentId === "");
          })
          .map((doc: any) => {
            const id = doc.id?.pk || doc.id;
            return {
              id,
              name: doc.name,
              forecast_group: doc.forecast_group || "general",
              parentIds: parentsByTypeId[String(id)] || []
            };
          });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  save() {
    this.saving = true;
    const updates: any[] = [];

    this.rows.forEach((row) => {
      updates.push(
        (this as any).$q(`UPDATE_TYPE_${row.id}`)
          .raw("documents.update")
          .action({
            schema_id: "s:products_types",
            id: row.id,
            document: {
              forecast_group: row.forecast_group
            }
          })
      );

      // Keep parent_product rows in sync; accounting still resolves via root type.
      (row.parentIds || []).forEach((parentId: any) => {
        updates.push(
          (this as any).$q(`UPDATE_PARENT_${parentId}`)
            .raw("documents.update")
            .action({
              schema_id: "s:products_types",
              id: parentId,
              document: {
                forecast_group: row.forecast_group
              }
            })
        );
      });
    });

    (this as any).$db(updates)
      .then(() => {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.log("[FIX] ProductTypeForecastGroupForm saved", {
            types: this.rows.length,
            updates: updates.length
          });
        }
        this.$buefy.toast.open({ message: "Сохранено", type: "is-success" });
        this.$emit("saved");
        this.$emit("close");
      })
      .catch((error: any) => {
        this.$buefy.toast.open({
          message: error?.message || "Ошибка сохранения",
          type: "is-danger"
        });
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
